import { createFileRoute } from '@tanstack/react-router'

import { SubmitStep } from '@/pages/tablet/create-booking-page'

export const Route = createFileRoute('/_tablet-layout/branch/$id/create/_wizard/submit')({
    component: SubmitStep,
})
